/********************************************************************
 * Copyright (c) Certus Software, 2021.                             *
 *                                                                  *
 * This unpublished material is proprietary to Certus Software.     *
 * All rights reserved. The methods and techniques described        *
 * herein are considered confidential and/or trade secrets.         *
 * Reproduction or distribution, in whole or in part, is forbidden  *
 * except by express written permission of Certus Software.         *
 ********************************************************************/

import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {User} from '../_models/user';
import {map} from 'rxjs/operators';
import {ApiService} from './api.service';
import {Report} from '../_models/report';
import {UserService} from './user.service';

@Injectable({
  providedIn: 'root'
})
export class LicenseService {

  constructor(
    private apiService: ApiService
  ) { }

  addLicenseCodes(licenseCodes): Observable<User> {
    return this.apiService.post('/rest-api/web/registered/v1.0/code/associate', licenseCodes);
  }

  fetchLicenses(licenseFetchData) {
    return this.apiService.post('/rest-api/web/registered/v1.0/user/codes', licenseFetchData);
  }

  downloadReport(): Observable<Blob> {
    const options = { responseType: 'blob' };
    return this.apiService.get('/rest-api/web/unregistered/v1.0/code/activation/report', options);
  }

  fetchAccountReport(code: string): Observable<Blob> {
    return this.apiService.postWithOptions(
      '/rest-api/web/registered/v1.0/user/code/activation/report',
      { code },
      { responseType: 'blob' }
    );
  }

  openPdfReport(code: string): void {
    const newTab = window.open('', '_self');

    this.fetchAccountReport(code).subscribe({
      next: (res: Blob) => {
        const url = URL.createObjectURL(res);
        newTab!.location.href = url;
        setTimeout(() => URL.revokeObjectURL(url), 10000);
      },
      error: () => {
        newTab?.close();
      }
    });
  }
}
